angular.module('unergie.main')
.controller('coordinatorCtrl', ($scope, $sce, AuthService, BoFeaturesService) => {
    const metabasePublicUrl = BoFeaturesService.getModuleFeatures('general').publicMetabaseUrl
    const coordinatorFeatures = BoFeaturesService.getModuleFeatures('coordinator')
    const dashboardId = _.get(coordinatorFeatures, `dashboardId.${AuthService.getOrg()}`)
    $scope.metabaseDashboardUrl = $sce.trustAsResourceUrl(`${metabasePublicUrl}public/dashboard/${dashboardId}`)
})
